import uuid from '../utils/uuid.utils';

export class ContactsEvent {
  static requestContacts(page = 0, size = 100) {
    window.__CAAS__.triggerNative(window.__CAAS__.events.getItems, uuid(), {
      type: 'contact',
      page,
      size,
    });
  }
}
